import { Flex } from "@chakra-ui/layout";

interface ContentItemProps {
  titulo: string;
  descricao?: string;
}

export default function ContentItem({ titulo, descricao }: ContentItemProps) {
  return (
    <Flex direction="column" mb="3">
      <Flex color="#768398" fontSize="12px">
        {titulo}
      </Flex>
      <Flex fontSize="13px">{descricao}</Flex>
    </Flex>
  );
}
